export default __webpack_public_path__ + "static/area-with-negative-values-44889a7e470f4474a888d51641808c26.png";